export default "__VITE_ASSET__48ridkxR__"